import { render } from "./CasesItemElement.vue?vue&type=template&id=0ebbb7d6&scoped=true"
import script from "./CasesItemElement.vue?vue&type=script&lang=js"
export * from "./CasesItemElement.vue?vue&type=script&lang=js"

import "./CasesItemElement.vue?vue&type=style&index=0&id=0ebbb7d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ebbb7d6"]])

export default __exports__